import React, { useCallback } from 'react';
import { styled } from "../../../../../stitches.config";
import { withThemeContext } from "../../../../../redesign/components/StitchesThemeProvider";
import Logo from "../../../../../redesign/atoms/Logo";
import Error404 from "../../../../../redesign/assets/innpolandRedesign/error-404.png";
import Error404BackgroundDark from "../../../../../redesign/assets/innpolandRedesign/error-404-background-dark.png";
import Error404BackgroundDarkMobile from "../../../../../redesign/assets/innpolandRedesign/error-404-background-dark-mobile.png";

interface IErrorPage {
    brand?: Config.Brand;
    isDarkMode?: boolean;
    description?: React.ReactNode;
}

const ErrorPage: React.FC<IErrorPage> = ({ brand = window.BRAND, isDarkMode, }) => {

    return (
        <>
            <Box isDarkMode={isDarkMode}>
                <Description>
                    <LogoWrapper>
                        <Logo type={isDarkMode ? "dark" : "white"} brand={brand} />
                    </LogoWrapper>
                    <p>Ups! <i>Nic tu nie ma</i></p>
                </Description>
                <Image src={Error404} />
                <Description>
                    <p>Znajdź <span>inn</span>ą stronę</p>
                </Description>
            </Box>
        </>
    );

};

export default withThemeContext(ErrorPage);

const Box = styled("div", {
    width: "100%",
    //maxWidth: "1272px",
    margin: "0 auto",
    color: "$grayscale100",
    paddingBottom: "32px",
    //position: "relative",
    paddingTop: "80px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",

    "@bp4": {
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center right",
        //height: "500px",
        paddingBottom: "48px",
    },

    variants: {
        isDarkMode: {
            true: {
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                backgroundImage: `url("${Error404BackgroundDarkMobile}")`,
                '@bp4': {
                    backgroundImage: `url("${Error404BackgroundDark}")`,
                },
            },
            false: {

            }
        }
    }
});

const Image = styled("img", {
    width: "100%",
    maxWidth: "300px",
    margin: "0 auto 40px auto",
    "@bp4": {
        maxWidth: "500px",
    }
});

const Description = styled("div", {
    maxWidth: "400px",
    width: "100%",
    padding: "0 24px",
    color: "$grayscale100",
    margin: "0 auto 0 auto",
    textAlign: "center",
    fontSize: "24px",
    lineHeight: "28px",

    "@bp4": {
        maxWidth: "520px",
        padding: "0",
        fontSize: "30px",
        lineHeight: "32px",
    },

    p: {
        textTransform: "uppercase",

        span: {
            color: "$primary",
            fontStyle: "italic",
        }
    }
});

const LogoWrapper = styled("div", {
    margin: "0 auto",
    width: "160px",
});

